import { NgxSchedulerCalendarDayViewComponent } from './calendar-day-view/ngx-scheduler-calendar-day-view.component';
import { NgxSchedulerCalendarContainerComponent } from './calendar-container/ngx-scheduler-calendar-container.component';
import { NgxSchedulerCalendarHeaderComponent } from './calendar-header/ngx-scheduler-calendar-header.component';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';

import { NgxSchedulerComponent } from './ngx-scheduler.component';


export class NgxSchedulerModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: NgxSchedulerModule
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [NgxSchedulerComponent, NgxSchedulerCalendarHeaderComponent, NgxSchedulerCalendarContainerComponent, NgxSchedulerCalendarDayViewComponent],
  imports: [CommonModule, FlexLayoutModule],
  exports: [NgxSchedulerComponent, NgxSchedulerCalendarHeaderComponent, NgxSchedulerCalendarContainerComponent, NgxSchedulerCalendarDayViewComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
